import { render, staticRenderFns } from "./QuoteResults.vue?vue&type=template&id=c20fea74&scoped=true"
import script from "./QuoteResults.vue?vue&type=script&lang=js"
export * from "./QuoteResults.vue?vue&type=script&lang=js"
import style0 from "./QuoteResults.vue?vue&type=style&index=0&id=c20fea74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20fea74",
  null
  
)

export default component.exports